import type { Member } from '../types';

export const clientMembersMock: Member[] = [
  {
    id: 'cm-1',
    userId: 'user-10',
    displayName: 'Cliente Usuario 1',
    email: 'cliente1@empresa.com',
    avatarUrl: null,
    role: 'collaborator',
    isActive: true,
    areaId: null,
    clientId: 'client-1',
    tenantId: 'tenant-1',
    expiresAt: '2025-12-31T23:59:59Z',
    createdAt: '2024-01-15T10:00:00Z',
    isCurrentUser: false,
  },
  {
    id: 'cm-2',
    userId: 'user-11',
    displayName: 'Cliente Usuario 2',
    email: 'cliente2@empresa.com',
    avatarUrl: null,
    role: 'collaborator',
    isActive: true,
    areaId: null,
    clientId: 'client-1',
    tenantId: 'tenant-1',
    expiresAt: null,
    createdAt: '2024-02-20T14:30:00Z',
    isCurrentUser: false,
  },
  {
    id: 'cm-3',
    userId: 'user-12',
    displayName: 'Cliente Usuario 3',
    email: 'cliente3@empresa.com',
    avatarUrl: null,
    role: 'client',
    isActive: false,
    areaId: null,
    clientId: 'client-1',
    tenantId: 'tenant-1',
    expiresAt: '2025-06-30T23:59:59Z',
    createdAt: '2024-03-10T09:00:00Z',
    isCurrentUser: false,
  },
];
